import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { RequestsService } from '../lib/requests.service'
import { REQUEST_BY_ID_RQ_KEY } from './useRequestById'
import { REQUESTS_LIST_RQ_KEY } from './useRequestsList'

const EDIT_REQUEST_AUTO = 'EDIT_REQUEST_AUTO'

type EditAutoBody = {
  number: string
  model: string
  isStandard: boolean
}

export const useEditRequestAuto = (requestId: string) => {
  const queryClient = useQueryClient()

  return useMutation<
    void,
    AxiosError<ServerValidationError>,
    {
      autoId: string
      body: EditAutoBody
    }
  >({
    mutationKey: [EDIT_REQUEST_AUTO, requestId],
    mutationFn: ({ autoId, body }) => RequestsService.editAuto(autoId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUEST_BY_ID_RQ_KEY, requestId]
      })
      queryClient.invalidateQueries({ queryKey: [REQUESTS_LIST_RQ_KEY] })
    }
  })
}
